import { LoginScreen } from '../public/LoginScreen';
import { PasswordResetScreen } from '../public/PasswordResetScreen';
import { RegisterScreen } from '../public/RegisterScreen';
import { NotFoundScreen } from '../public/NotFoundScreen';
import { ContentOnlyLayout } from '@/components/layout/ContentOnlyLayout';
import { StorybookScreen } from '../public/StorybookScreen';
import { SurveyResponseScreen } from '../public/SurveyResponseScreen';
import { SurveyPreviewScreen } from '../public/SurveyPreviewScreen';
import { AppRoutes } from '../AppRoutes';
import { RegisterConsultingCompanyScreen } from '../public/RegisterConsultingCompanyScreen';

export const usePublicRouteConfig = () => {
  return [
    // Login
    {
      path: '/login',
      element: <LoginScreen />,
    },
    // Password Reset
    {
      path: '/forgot-password',
      element: <PasswordResetScreen />,
    },
    // Register
    {
      path: AppRoutes.Register,
      element: <RegisterScreen />,
    },
    {
      path: AppRoutes.RegisterConsultingCompany,
      element: <RegisterConsultingCompanyScreen />,
    },
    // 404
    {
      path: '*',
      element: <NotFoundScreen />,
    },
    // Other public pages
    {
      path: '/public',
      element: <ContentOnlyLayout />,
      children: [
        {
          index: true,
          element: <NotFoundScreen />,
        },
        // Design system
        {
          path: '/public/design-system',
          element: <StorybookScreen />,
        },
      ],
    },
    // Public survey page
    {
      path: '/survey/:surveyId',
      element: <ContentOnlyLayout />,
      children: [
        {
          path: '/survey/:surveyId/answer',
          element: <SurveyResponseScreen />,
        },
        {
          path: '/survey/:surveyId/response/:responseId',
          element: <SurveyResponseScreen />,
        },
        {
          path: '/survey/:surveyId/preview',
          element: <SurveyPreviewScreen />,
        },
      ],
    },
  ];
};
